<template>
    <div>
        <v-card flat>
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <b> Print Receipt </b>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-btn v-if="learner_receipt_data != null" id="wv_btn" class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
            <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                <v-radio label="Both" value="both" color="#0f2027"></v-radio>
                <v-radio label="Office Copy" value="office" color="#0f2027"></v-radio>
                <v-radio label="Student Copy" value="student" color="#0f2027"></v-radio>
            </v-radio-group>
            <div id="document1">
            <v-row v-if="learner_receipt_data != null && radios != 'both'">
                <v-col cols="12" sm="6" md="6" class="m-0 p-0" v-if="radios == 'office'">
                    <v-card flat>
                        <v-simple-table dense class="elevation-1 table-container">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <td colspan="3">
                                            <center><b>Fee Receipt</b></center>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th v-if="org_basic_data.trust_logo" style="width: 25%;">
                                            <!-- <center> -->
                                            <img :src="org_basic_data.trust_logo" width="90%" alt="logo" />
                                            <!-- </center> -->
                                        </th>
                                        <td style="width: 50%;">
                                            <center>
                                                    <span v-if="org_basic_data.trust_name"><b>{{ org_basic_data.trust_name }}</b></span><br>
                                                    <span v-if="org_basic_data.school_name"><b>{{ org_basic_data.school_name }} </b></span><br>
                                                    <span v-if="org_basic_data.address">{{ org_basic_data.address }}</span><br>
                                                    <span  v-if="org_basic_data.phone"> Phone : {{ org_basic_data.phone }}</span><br>
                                                    <span v-if="org_basic_data.email">Email : {{ org_basic_data.email }}</span><br>                                             
                                                    <span v-if="org_basic_data.website"></span>Website : {{ org_basic_data.website }}
                                            </center>
                                        </td>
                                        <th v-if="org_basic_data.school_logo" style="width: 25%;">
                                            <center>
                                                <img :src="org_basic_data.school_logo" width="80%" alt="logo" />
                                            </center>
                                        </th>
                                    </tr>

                                    <tr>
                                        <td colspan="1">
                                            PRN No. : {{ learner_receipt_data.registration_number }}
                                        </td>
                                        <td colspan="1">
                                            Student Name : {{ learner_receipt_data.name }}
                                        </td>
                                        <td colspan="1">
                                            Office Copy
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left" colspan="1">
                                            Fee Details For : {{ learner_receipt_data.ay }}
                                        </td>
                                        <td colspan="1">
                                            Receipt No : {{ learner_receipt_data.receipt_no }}
                                        </td>
                                        <td colspan="1">
                                            Standard : {{ learner_receipt_data.standard }}
                                        </td>
                                        <!-- <td colspan="1">
                                            Receipt Date : {{learner_receipt_data.receipt_date}}
                                        </td> -->
                                    </tr>
                                    <tr>
                                        <td class="text-left" colspan="3">
                                            Transaction Date : {{ learner_receipt_data.transaction_date }}
                                            <span class="ml-10 text-center"></span> Receipt Date : {{ learner_receipt_data.receipt_date }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left" colspan="2">
                                            <b>Fee Type</b>
                                        </td>
                                        <td><b> Fee Amount (Rs.)</b></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in learner_receipt_data.student_receipt_details" :key="item.id">
                                        <td class="text-left" colspan="2">
                                            {{ item.component }}
                                        </td>
                                        <td>{{ item.amount }}</td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <td class="text-left" colspan="2">
                                        <b>Fine </b>
                                    </td>
                                    <td>Rs. {{ learner_receipt_data.fine }}</td>
                                </tr>
                                <tr>
                                    <td class="text-left" colspan="2">
                                        <b>Excess Amount </b>
                                    </td>
                                    <td>Rs. {{ learner_receipt_data.excess_amount }}</td>
                                </tr>
                                <tr>
                                    <td class="text-left" colspan="2">
                                        <b>Total Amount </b>
                                    </td>
                                    <td>Rs. {{ learner_receipt_data.total_fees_amount }}.00</td>
                                </tr>

                                <tr>
                                    <td colspan="3" class="text-left">
                                        <!-- <v-col cols="12" md="12" sm="12"> -->
                                        <b> Amount in words ::</b>
                                        {{ learner_receipt_data.amount_in_words }}
                                        <!-- </v-col> -->
                                    </td>
                                </tr>
                                <!-- <tr>
                                    <td colspan="3" class="text-left"><b> Total Payable Amount ::</b> Rs. {{learner_receipt_data.total_fees_amount}}.00 ( {{ convert(learner_receipt_data.total_fees_amount) }} Only)</td>
                                </tr> -->
                                <tr>
                                    <td colspan="3" class="text-left">
                                        <b> Payment Mode :: </b>
                                        {{ learner_receipt_data.payment_mode }}
                                        
                                        <b class="ml-10 text-center"> Transaction Id :: </b>
                                        {{ learner_receipt_data.trnx_id }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left">
                                        <b> Payment Details:</b>
                                        {{ learner_receipt_data.remark }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left">
                                        <b> Balance Fee:</b>
                                        {{ learner_receipt_data.balance_amount }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-right">
                                        <v-col cols="12" md="12" sm="12">
                                            <b>Authorized Signature</b>
                                        </v-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left">
                                        * Fee received is subject to clearance of cheque/online transaction
                                    </td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="m-0 p-0" v-if="radios == 'student'">
                    <v-card flat>
                        <v-simple-table dense class="elevation-1 table-container">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <td colspan="3">
                                            <center><b>Fee Receipt</b></center>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th v-if="org_basic_data.trust_logo" style="width: 25%;">
                                            <!-- <center> -->
                                            <img :src="org_basic_data.trust_logo" width="90%" alt="logo" />
                                            <!-- </center> -->
                                        </th>
                                        <td style="width: 50%;">
                                             <center>
                                                    <span v-if="org_basic_data.trust_name"><b>{{ org_basic_data.trust_name }}</b></span><br>
                                                    <span v-if="org_basic_data.school_name"><b>{{ org_basic_data.school_name }} </b></span><br>
                                                    <span v-if="org_basic_data.address">{{ org_basic_data.address }}</span><br>
                                                    <span  v-if="org_basic_data.phone"> Phone : {{ org_basic_data.phone }}</span><br>
                                                    <span v-if="org_basic_data.email">Email : {{ org_basic_data.email }}</span><br>                                             
                                                    <span v-if="org_basic_data.website"></span>Website : {{ org_basic_data.website }}
                                            </center>
                                        </td>
                                        <th v-if="org_basic_data.school_logo" style="width: 25%;">
                                            <center>
                                                <img :src="org_basic_data.school_logo" width="80%" alt="logo" />
                                            </center>
                                        </th>
                                    </tr>
                                    <tr>
                                        <td colspan="1">
                                            PRN No. : {{ learner_receipt_data.registration_number }}
                                        </td>
                                        <td colspan="1">
                                            Student Name : {{ learner_receipt_data.name }}
                                        </td>
                                        <td colspan="1">
                                            Student Copy
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left" colspan="1">
                                            Fee Details For : {{ learner_receipt_data.ay }}
                                        </td>
                                        <td colspan="1">
                                            Receipt No : {{ learner_receipt_data.receipt_no }}
                                        </td>
                                        <td colspan="1">
                                            Standard : {{ learner_receipt_data.standard }}
                                        </td>
                                        <!-- <td colspan="1">
                                            Receipt Date : {{learner_receipt_data.receipt_date}}
                                        </td> -->
                                    </tr>
                                    <tr>
                                        <td class="text-left" colspan="3">
                                            Transaction Date : {{ learner_receipt_data.transaction_date }}
                                           <span class="ml-10 text-center"></span> Receipt Date : {{ learner_receipt_data.receipt_date }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left" colspan="2">
                                            <b>Fee Type</b>
                                        </td>
                                        <td><b> Fee Amount (Rs.)</b></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in learner_receipt_data.student_receipt_details" :key="item.id">
                                        <td class="text-left" colspan="2">
                                            {{ item.component }}
                                        </td>
                                        <td>{{ item.amount }}</td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <td class="text-left" colspan="2">
                                        <b>Fine </b>
                                    </td>
                                    <td>Rs. {{ learner_receipt_data.fine }}</td>
                                </tr>
                                <tr>
                                    <td class="text-left" colspan="2">
                                        <b>Excess Amount </b>
                                    </td>
                                    <td>Rs. {{ learner_receipt_data.excess_amount }}</td>
                                </tr>
                                <tr>
                                    <td class="text-left" colspan="2">
                                        <b>Total Amount </b>
                                    </td>
                                    <td>Rs. {{ learner_receipt_data.total_fees_amount }}.00</td>
                                </tr>

                                <tr>
                                    <td colspan="3" class="text-left">
                                        <!-- <v-col cols="12" md="12" sm="12"> -->
                                        <b> Amount in words ::</b>
                                        {{ learner_receipt_data.amount_in_words }}
                                        <!-- </v-col> -->
                                    </td>
                                </tr>
                                <!-- <tr>
                                    <td colspan="3" class="text-left"><b> Total Payable Amount ::</b> Rs. {{learner_receipt_data.total_fees_amount}}.00 ( {{ convert(learner_receipt_data.total_fees_amount) }} Only)</td>
                                </tr> -->
                                <tr>
                                    <td colspan="3" class="text-left">
                                        <b> Payment Mode :: </b>
                                        {{ learner_receipt_data.payment_mode }}
                                        <b class="ml-10 text-center"> Transaction Id :: </b>
                                        {{ learner_receipt_data.trnx_id }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left">
                                        <b> Payment Details:</b>
                                        {{ learner_receipt_data.remark }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left">
                                        <b> Balance Fee:</b>
                                        {{ learner_receipt_data.balance_amount }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-right">
                                        <v-col cols="12" md="12" sm="12">
                                            <b>Authorized Signature</b>
                                        </v-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left">
                                        * Fee received is subject to clearance of cheque/online transaction
                                    </td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
            </v-row>
            <v-row v-if="learner_receipt_data != null && radios == 'both'">
                <v-col cols="12" sm="6" md="6" class="m-0 p-0">
                    <v-card flat>
                        <v-simple-table dense class="elevation-1 table-container">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <td colspan="3">
                                            <center><b>Fee Receipt</b></center>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th v-if="org_basic_data.trust_logo" style="width: 25%;">
                                            <!-- <center> -->
                                            <img width="90%" :src="org_basic_data.trust_logo" alt="logo" />
                                            <!-- </center> -->
                                        </th>
                                        <td style="width: 50%;">
                                            <center>
                                                    <span v-if="org_basic_data.trust_name"><b>{{ org_basic_data.trust_name }}</b></span><br>
                                                    <span v-if="org_basic_data.school_name"><b>{{ org_basic_data.school_name }} </b></span><br>
                                                    <span v-if="org_basic_data.address">{{ org_basic_data.address }}</span><br>
                                                    <span  v-if="org_basic_data.phone"> Phone : {{ org_basic_data.phone }}</span><br>
                                                    <span v-if="org_basic_data.email">Email : {{ org_basic_data.email }}</span><br>                                             
                                                    <span v-if="org_basic_data.website"></span>Website : {{ org_basic_data.website }}
                                            </center>
                                        </td>
                                        <th v-if="org_basic_data.school_logo" style="width: 25%;">
                                            <center>
                                                <img width="80%" :src="org_basic_data.school_logo" alt="logo" />
                                            </center>
                                        </th>
                                    </tr>
                                    <tr>
                                        <td colspan="1">
                                            PRN No. : {{ learner_receipt_data.registration_number }}
                                        </td>
                                        <td colspan="1">
                                            Student Name : {{ learner_receipt_data.name }}
                                        </td>
                                        <td colspan="1">
                                            Office Copy
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left" colspan="1">
                                            Fee Details For : {{ learner_receipt_data.ay }}
                                        </td>
                                        <td colspan="1">
                                            Receipt No : {{ learner_receipt_data.receipt_no }}
                                        </td>
                                        <td colspan="1">
                                            Standard : {{ learner_receipt_data.standard }}
                                        </td>
                                        <!-- <td colspan="1">
                                            Receipt Date : {{learner_receipt_data.receipt_date}}
                                        </td> -->
                                    </tr>
                                    <tr>
                                        <td class="text-left" colspan="3">
                                            Transaction Date : {{ learner_receipt_data.transaction_date }}
                                            <span class="ml-10 text-center"></span> Receipt Date : {{ learner_receipt_data.receipt_date }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left" colspan="2">
                                            <b>Fee Type</b>
                                        </td>
                                        <td><b> Fee Amount (Rs.)</b></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in learner_receipt_data.student_receipt_details" :key="item.id">
                                        <td class="text-left" colspan="2">
                                            {{ item.component }}
                                        </td>
                                        <td>{{ item.amount }}</td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <td class="text-left" colspan="2">
                                        <b>Fine </b>
                                    </td>
                                    <td>Rs. {{ learner_receipt_data.fine }}</td>
                                </tr>
                                <tr>
                                    <td class="text-left" colspan="2">
                                        <b>Excess Amount </b>
                                    </td>
                                    <td>Rs. {{ learner_receipt_data.excess_amount }}</td>
                                </tr>
                                <tr>
                                    <td class="text-left" colspan="2">
                                        <b>Total Amount </b>
                                    </td>
                                    <td>Rs. {{ learner_receipt_data.total_fees_amount }}.00</td>
                                </tr>

                                <tr>
                                    <td colspan="3" class="text-left">
                                        <!-- <v-col cols="12" md="12" sm="12"> -->
                                        <b> Amount in words ::</b>
                                        {{ learner_receipt_data.amount_in_words }}
                                        <!-- </v-col> -->
                                    </td>
                                </tr>
                                <!-- <tr>
                                    <td colspan="3" class="text-left"><b> Total Payable Amount ::</b> Rs. {{learner_receipt_data.total_fees_amount}}.00 ( {{ convert(learner_receipt_data.total_fees_amount) }} Only)</td>
                                </tr> -->
                                <tr>
                                    <td colspan="3" class="text-left">
                                        <b> Payment Mode :: </b>
                                        {{ learner_receipt_data.payment_mode }}
                                        <b class="ml-10 text-center"> Transaction Id :: </b>
                                        {{ learner_receipt_data.trnx_id }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left">
                                        <b> Payment Details:</b>
                                        {{ learner_receipt_data.remark }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left">
                                        <b> Balance Fee:</b>
                                        {{ learner_receipt_data.balance_amount }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-right">
                                        <v-col cols="12" md="12" sm="12">
                                            <b>Authorized Signature</b>
                                        </v-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left">
                                        * Fee received is subject to clearance of cheque/online transaction
                                    </td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="m-0 p-0">
                    <v-card flat>
                        <v-simple-table dense class="elevation-1 table-container">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <td colspan="3">
                                            <center><b>Fee Receipt</b></center>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th v-if="org_basic_data.trust_logo" style="width: 25%;">
                                            <!-- <center> -->
                                            <img :src="org_basic_data.trust_logo" width="90%" alt="logo" />
                                            <!-- </center> -->
                                        </th>
                                        <td style="width: 50%;">
                                             <center>
                                                    <span v-if="org_basic_data.trust_name"><b>{{ org_basic_data.trust_name }}</b></span><br>
                                                    <span v-if="org_basic_data.school_name"><b>{{ org_basic_data.school_name }} </b></span><br>
                                                    <span v-if="org_basic_data.address">{{ org_basic_data.address }}</span><br>
                                                    <span  v-if="org_basic_data.phone"> Phone : {{ org_basic_data.phone }}</span><br>
                                                    <span v-if="org_basic_data.email">Email : {{ org_basic_data.email }}</span><br>                                             
                                                    <span v-if="org_basic_data.website"></span>Website : {{ org_basic_data.website }}
                                            </center>
                                        </td>
                                        <th v-if="org_basic_data.school_logo" style="width: 25%;">
                                            <center>
                                                <img :src="org_basic_data.school_logo" width="80%" alt="logo" />
                                            </center>
                                        </th>
                                    </tr>
                                    <tr>
                                        <td colspan="1">
                                            PRN No. : {{ learner_receipt_data.registration_number }}
                                        </td>
                                        <td colspan="1">
                                            Student Name : {{ learner_receipt_data.name }}
                                        </td>
                                        <td colspan="1">
                                            Student Copy
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left" colspan="1">
                                            Fee Details For : {{ learner_receipt_data.ay }}
                                        </td>
                                        <td colspan="1">
                                            Receipt No : {{ learner_receipt_data.receipt_no }}
                                        </td>
                                        <td colspan="1">
                                            Standard : {{ learner_receipt_data.standard }}
                                        </td>
                                        <!-- <td colspan="1">
                                            Receipt Date : {{learner_receipt_data.receipt_date}}
                                        </td> -->
                                    </tr>
                                    <tr>
                                        <td class="text-left" colspan="3">
                                            Transaction Date : {{ learner_receipt_data.transaction_date }}
                                            <span class="ml-10 text-center"></span> Receipt Date : {{ learner_receipt_data.receipt_date }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left" colspan="2">
                                            <b>Fee Type</b>
                                        </td>
                                        <td><b> Fee Amount (Rs.)</b></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in learner_receipt_data.student_receipt_details" :key="item.id">
                                        <td class="text-left" colspan="2">
                                            {{ item.component }}
                                        </td>
                                        <td>{{ item.amount }}</td>
                                    </tr>
                                </tbody>
                                <tr>
                                    <td class="text-left" colspan="2">
                                        <b>Fine </b>
                                    </td>
                                    <td>Rs. {{ learner_receipt_data.fine }}</td>
                                </tr>
                                <tr>
                                    <td class="text-left" colspan="2">
                                        <b>Excess Amount </b>
                                    </td>
                                    <td>Rs. {{ learner_receipt_data.excess_amount }}</td>
                                </tr>
                                <tr>
                                    <td class="text-left" colspan="2">
                                        <b>Total Amount </b>
                                    </td>
                                    <td>Rs. {{ learner_receipt_data.total_fees_amount }}.00</td>
                                </tr>

                                <tr>
                                    <td colspan="3" class="text-left">
                                        <!-- <v-col cols="12" md="12" sm="12"> -->
                                        <b> Amount in words ::</b>
                                        {{ learner_receipt_data.amount_in_words }}
                                        <!-- </v-col> -->
                                    </td>
                                </tr>
                                <!-- <tr>
                                    <td colspan="3" class="text-left"><b> Total Payable Amount ::</b> Rs. {{learner_receipt_data.total_fees_amount}}.00 ( {{ convert(learner_receipt_data.total_fees_amount) }} Only)</td>
                                </tr> -->
                                <tr>
                                    <td colspan="3" class="text-left">
                                        <b> Payment Mode :: </b>
                                        {{ learner_receipt_data.payment_mode }}
                                       <b class="ml-10 text-center"> Transaction Id :: </b>
                                        {{ learner_receipt_data.trnx_id }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left">
                                        <b> Payment Details:</b>
                                        {{ learner_receipt_data.remark }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left">
                                        <b> Balance Fee:</b>
                                        {{ learner_receipt_data.balance_amount }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-right">
                                        <v-col cols="12" md="12" sm="12">
                                            <b>Authorized Signature</b>
                                        </v-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="text-left">
                                        * Fee received is subject to clearance of cheque/online transaction
                                    </td>
                                </tr>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
            </v-row>
            </div>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                overlay: false,
                learner_receipt_data: null,
                radios: null,
                receipt_no: null,
                registration_no: null,
                ay: null,
                org_basic_data: [],
            };
        },
        watch: {
            receipt_no() {
                this.getData();
            },

            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        created() {
            this.receipt_no = JSON.parse(this.$session.get("receipt_no"));
            this.ay = JSON.parse(this.$session.get("ay"));
            this.registration_no = JSON.parse(this.$session.get("registration_no"));
        },
        mounted() {
            this.getData();
        },
        methods: {
             print() {
            var content = document.getElementById("document1").innerHTML;
            var mywindow = document.body.innerHTML;
            document.body.innerHTML = content;
            window.print();
            document.body.innerHTML = mywindow;
            location.reload();
            return true;
        },
            convert(number) {
                var converter = require("number-to-words");
                const string = converter.toWords(number);
                const string1 = string.charAt(0).toUpperCase() + string.slice(1);
                return string1;
            },
            getData() {
                this.overlay = true;
                this.learner_receipt_data = null;
                const formData = {
                    receipt_no: this.receipt_no,
                    registration_no: this.registration_no,
                    ay: this.ay,
                };
                axios
                    .post("/AccountingAndFeesReports/getFeeReceipts", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_receipt_data = res.data.student_receipt_details;
                            this.org_basic_data = res.data.org_basic_data;
                            this.overlay = false;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            this.overlay = false;
                            return;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        //close loader
                        this.overlay = false;
                    });
            },
        },
    };
</script>
<style scoped>
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    tr {
        /* font-size: 0px; */
        /* white-space: nowrap; */
    }
    th,
    td {
        display: inline-block;
    }

    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        /* text-align: center; */
    }
    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        img {
            width: 100% !important;
        }
        body,
        tr,
        th,
        td {
            font-size: x-large !important;
            font-weight: bold !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        @page {
            size: A4 landscape;
            margin-top: none;
            padding-top: none;
            size: 25in 20in;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin: 0.7rem !important;
            padding: 0.7rem !important;
            font-size: x-large !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
        .text-left{
            text-align: left !important;
        }
        .text-right{
            text-align: right !important;
        }
        .text-center{
            /* text-align: center !important; */
            margin-left: 32px;
        }
    }
    .table-container {
        overflow-x: hidden;
        overflow: hidden;
        margin-left: 5rem !important;
    }
    .text {
        color: red !important;
        font-size: bold !important;
    }
    .schlogo {
        width: 160px;
        height: 155px;
    }
</style>
